/**
 * Transform Peatix API event to our UI Event type.
 *
 * Handles both v4 API shape and legacy/mock shape.
 */
export function transformPeatixEvent(peatixEvent: any) {
  // --- Date: v4 uses start/end objects; legacy uses flat fields ---
  const date = peatixEvent.start?.utc || peatixEvent.startDate || '';
  const endDate = peatixEvent.end?.utc || peatixEvent.endDate;

  // --- Timezone ---
  const timezone = peatixEvent.start?.timezone || peatixEvent.timezone;

  // --- Image: v4 coverImage → legacy image/imageUrl → group logo fallback ---
  const image =
    peatixEvent.coverImage ||
    peatixEvent.image ||
    peatixEvent.imageUrl ||
    peatixEvent.group?.logo;

  // --- Title: v4 uses name; legacy uses title ---
  const title = peatixEvent.name || peatixEvent.title || '';

  // --- Organizer: v4 uses nickname; legacy uses name/displayName ---
  const organizer =
    peatixEvent.organizer?.nickname ||
    peatixEvent.organizer?.name ||
    peatixEvent.organizer?.displayName;

  // --- URL: v4 doesn't return a url field; construct from id ---
  const url =
    peatixEvent.url ||
    peatixEvent.eventUrl ||
    (peatixEvent.id ? `https://peatix.com/event/${peatixEvent.id}` : '');

  // --- Venue: v4 uses locationSettings; legacy uses venue object ---
  const venue =
    peatixEvent.locationSettings?.venueName ||
    peatixEvent.venue?.name;

  // --- Venue address ---
  const ls = peatixEvent.locationSettings;
  const legacyAddr = peatixEvent.venue?.address;
  const venueAddress = ls
    ? {
        streetAddress: ls.venueAddress,
        addressLocality: ls.venueCity || ls.venueCityLong,
        addressRegion: ls.venueStateLong || ls.venueStateShort,
        postalCode: undefined,
        addressCountry: ls.venueCountryCode,
      }
    : legacyAddr
      ? {
          streetAddress: legacyAddr.streetAddress,
          addressLocality: legacyAddr.addressLocality,
          postalCode: legacyAddr.postalCode,
          addressRegion: legacyAddr.addressRegion,
          addressCountry: legacyAddr.addressCountry,
        }
      : undefined;

  // --- isFree: v4 uses badges.isFree; legacy uses top-level isFree or price ---
  const isFree =
    peatixEvent.badges?.isFree ??
    peatixEvent.isFree ??
    (peatixEvent.price?.min === 0 && !peatixEvent.price?.max) ??
    false;

  return {
    id: String(peatixEvent.id || ''),
    date,
    endDate,
    title,
    venue,
    venueAddress,
    isFree,
    url,
    image,
    organizer,
    timezone,
  };
}
